const countries = [
  { name: "Afghanistan", code: "AFG", telCode: "93" },
  { name: "Albania", code: "ALB", telCode: "355" },
  { name: "Algeria", code: "DZA", telCode: "213" },
  { name: "American Samoa", code: "ASM", telCode: "1" },
  { name: "Andorra", code: "AND", telCode: "376" },
  { name: "Angola", code: "AGO", telCode: "244" },
  { name: "Anguilla", code: "AIA", telCode: "1" },
  { name: "Antarctica", code: "ATA", telCode: "672" },
  { name: "Antigua and Barbuda", code: "ATG", telCode: "1" },
  { name: "Argentina", code: "ARG", telCode: "54" },
  { name: "Armenia", code: "ARM", telCode: "374" },
  { name: "Aruba", code: "ABW", telCode: "297" },
  { name: "Australia", code: "AUS", telCode: "61" },
  { name: "Austria", code: "AUT", telCode: "43" },
  { name: "Azerbaijan", code: "AZE", telCode: "994" },
  { name: "Bahamas", code: "BHS", telCode: "1" },
  { name: "Bahrain", code: "BHR", telCode: "973" },
  { name: "Bangladesh", code: "BGD", telCode: "880" },
  { name: "Barbados", code: "BRB", telCode: "1" },
  { name: "Belarus", code: "BLR", telCode: "375" },
  { name: "Belgium", code: "BEL", telCode: "32" },
  { name: "Belize", code: "BLZ", telCode: "501" },
  { name: "Benin", code: "BEN", telCode: "229" },
  { name: "Bermuda", code: "BMU", telCode: "1" },
  { name: "Bhutan", code: "BTN", telCode: "975" },
  { name: "Bolivia (Plurinational State of)", code: "BOL", telCode: "591" },
  { name: "Bonaire, Sint Eustatius and Saba", code: "BES", telCode: "599" },
  { name: "Bosnia and Herzegovina", code: "BIH", telCode: "387" },
  { name: "Botswana", code: "BWA", telCode: "267" },
  { name: "Bouvet Island", code: "BVT", telCode: "47" },
  { name: "Brazil", code: "BRA", telCode: "55" },
  { name: "British Indian Ocean Territory", code: "IOT", telCode: "246" },
  { name: "Brunei Darussalam", code: "BRN", telCode: "673" },
  { name: "Bulgaria", code: "BGR", telCode: "359" },
  { name: "Burkina Faso", code: "BFA", telCode: "226" },
  { name: "Burundi", code: "BDI", telCode: "257" },
  { name: "Cabo Verde", code: "CPV", telCode: "238" },
  { name: "Cambodia", code: "KHM", telCode: "855" },
  { name: "Cameroon", code: "CMR", telCode: "237" },
  { name: "Canada", code: "CAN", telCode: "1" },
  { name: "Cayman Islands", code: "CYM", telCode: "1" },
  { name: "Central African Republic", code: "CAF", telCode: "236" },
  { name: "Chad", code: "TCD", telCode: "235" },
  { name: "Chile", code: "CHL", telCode: "56" },
  { name: "China", code: "CHN", telCode: "86" },
  { name: "Christmas Island", code: "CXR", telCode: "61" },
  { name: "Cocos (Keeling) Islands", code: "CCK", telCode: "61" },
  { name: "Colombia", code: "COL", telCode: "57" },
  { name: "Comoros", code: "COM", telCode: "269" },
  { name: "Congo", code: "COG", telCode: "242" },
  { name: "Congo (Democratic Republic of the)", code: "COD", telCode: "243" },
  { name: "Cook Islands", code: "COK", telCode: "682" },
  { name: "Costa Rica", code: "CRI", telCode: "506" },
  { name: "Ivory Coast", code: "CIV", telCode: "225" },
  { name: "Croatia", code: "HRV", telCode: "385" },
  { name: "Cuba", code: "CUB", telCode: "53" },
  { name: "Cura\u00e7ao", code: "CUW", telCode: "599" },
  { name: "Cyprus", code: "CYP", telCode: "357" },
  { name: "Czech Republic", code: "CZE", telCode: "420" },
  { name: "Denmark", code: "DNK", telCode: "45" },
  { name: "Djibouti", code: "DJI", telCode: "253" },
  { name: "Dominica", code: "DMA", telCode: "1" },
  { name: "Dominican Republic", code: "DOM", telCode: "1" },
  { name: "Ecuador", code: "ECU", telCode: "593" },
  { name: "Egypt", code: "EGY", telCode: "20" },
  { name: "El Salvador", code: "SLV", telCode: "503" },
  { name: "Equatorial Guinea", code: "GNQ", telCode: "240" },
  { name: "Eritrea", code: "ERI", telCode: "291" },
  { name: "Estonia", code: "EST", telCode: "372" },
  { name: "Swaziland", code: "SWZ", telCode: "268" },
  { name: "Ethiopia", code: "ETH", telCode: "251" },
  { name: "Falkland Islands (Malvinas)", code: "FLK", telCode: "500" },
  { name: "Faroe Islands", code: "FRO", telCode: "298" },
  { name: "Fiji", code: "FJI", telCode: "679" },
  { name: "Finland", code: "FIN", telCode: "358" },
  { name: "France", code: "FRA", telCode: "33" },
  { name: "French Guiana", code: "GUF", telCode: "594" },
  { name: "French Polynesia", code: "PYF", telCode: "689" },
  { name: "French Southern Territories", code: "ATF", telCode: "262" },
  { name: "Gabon", code: "GAB", telCode: "241" },
  { name: "Gambia", code: "GMB", telCode: "220" },
  { name: "Georgia", code: "GEO", telCode: "995" },
  { name: "Germany", code: "DEU", telCode: "49" },
  { name: "Ghana", code: "GHA", telCode: "233" },
  { name: "Gibraltar", code: "GIB", telCode: "350" },
  { name: "Greece", code: "GRC", telCode: "30" },
  { name: "Greenland", code: "GRL", telCode: "299" },
  { name: "Grenada", code: "GRD", telCode: "1" },
  { name: "Guadeloupe", code: "GLP", telCode: "590" },
  { name: "Guam", code: "GUM", telCode: "1" },
  { name: "Guatemala", code: "GTM", telCode: "502" },
  { name: "Guernsey", code: "GGY", telCode: "44" },
  { name: "Guinea", code: "GIN", telCode: "224" },
  { name: "Guinea-Bissau", code: "GNB", telCode: "245" },
  { name: "Guyana", code: "GUY", telCode: "592" },
  { name: "Haiti", code: "HTI", telCode: "509" },
  { name: "Heard Island and McDonald Islands", code: "HMD", telCode: "672" },
  { name: "Vatican City", code: "VAT", telCode: "379" },
  { name: "Honduras", code: "HND", telCode: "504" },
  { name: "Hong Kong", code: "HKG", telCode: "852" },
  { name: "Hungary", code: "HUN", telCode: "36" },
  { name: "Iceland", code: "ISL", telCode: "354" },
  { name: "India", code: "IND", telCode: "91" },
  { name: "Indonesia", code: "IDN", telCode: "62" },
  { name: "Iran (Islamic Republic of)", code: "IRN", telCode: "98" },
  { name: "Iraq", code: "IRQ", telCode: "964" },
  { name: "Ireland", code: "IRL", telCode: "353" },
  { name: "Isle of Man", code: "IMN", telCode: "44" },
  { name: "Israel", code: "ISR", telCode: "972" },
  { name: "Italy", code: "ITA", telCode: "39" },
  { name: "Jamaica", code: "JAM", telCode: "1" },
  { name: "Japan", code: "JPN", telCode: "81" },
  { name: "Jersey", code: "JEY", telCode: "44" },
  { name: "Jordan", code: "JOR", telCode: "962" },
  { name: "Kazakhstan", code: "KAZ", telCode: "76" },
  { name: "Kenya", code: "KEN", telCode: "254" },
  { name: "Kiribati", code: "KIR", telCode: "686" },
  {
    name: "Korea (Democratic People's Republic of)",
    code: "PRK",
    telCode: 850,
  },
  { name: "Korea (Republic of)", code: "KOR", telCode: "82" },
  { name: "Kuwait", code: "KWT", telCode: "965" },
  { name: "Kyrgyzstan", code: "KGZ", telCode: "996" },
  { name: "Lao People's Democratic Republic", code: "LAO", telCode: 856 },
  { name: "Latvia", code: "LVA", telCode: "371" },
  { name: "Lebanon", code: "LBN", telCode: "961" },
  { name: "Lesotho", code: "LSO", telCode: "266" },
  { name: "Liberia", code: "LBR", telCode: "231" },
  { name: "Libya", code: "LBY", telCode: "218" },
  { name: "Liechtenstein", code: "LIE", telCode: "423" },
  { name: "Lithuania", code: "LTU", telCode: "370" },
  { name: "Luxembourg", code: "LUX", telCode: "352" },
  { name: "Macao", code: "MAC", telCode: "853" },
  { name: "Madagascar", code: "MDG", telCode: "261" },
  { name: "Malawi", code: "MWI", telCode: "265" },
  { name: "Malaysia", code: "MYS", telCode: "60" },
  { name: "Maldives", code: "MDV", telCode: "960" },
  { name: "Mali", code: "MLI", telCode: "223" },
  { name: "Malta", code: "MLT", telCode: "356" },
  { name: "Marshall Islands", code: "MHL", telCode: "692" },
  { name: "Martinique", code: "MTQ", telCode: "596" },
  { name: "Mauritania", code: "MRT", telCode: "222" },
  { name: "Mauritius", code: "MUS", telCode: "230" },
  { name: "Mayotte", code: "MYT", telCode: "262" },
  { name: "Mexico", code: "MEX", telCode: "52" },
  { name: "Micronesia (Federated States of)", code: "FSM", telCode: "691" },
  { name: "Moldova (Republic of)", code: "MDA", telCode: "373" },
  { name: "Monaco", code: "MCO", telCode: "377" },
  { name: "Mongolia", code: "MNG", telCode: "976" },
  { name: "Montenegro", code: "MNE", telCode: "382" },
  { name: "Montserrat", code: "MSR", telCode: "1" },
  { name: "Morocco", code: "MAR", telCode: "212" },
  { name: "Mozambique", code: "MOZ", telCode: "258" },
  { name: "Myanmar", code: "MMR", telCode: "95" },
  { name: "Namibia", code: "NAM", telCode: "264" },
  { name: "Nauru", code: "NRU", telCode: "674" },
  { name: "Nepal", code: "NPL", telCode: "977" },
  { name: "Netherlands", code: "NLD", telCode: "31" },
  { name: "New Caledonia", code: "NCL", telCode: "687" },
  { name: "New Zealand", code: "NZL", telCode: "64" },
  { name: "Nicaragua", code: "NIC", telCode: "505" },
  { name: "Niger", code: "NER", telCode: "227" },
  { name: "Nigeria", code: "NGA", telCode: "234" },
  { name: "Niue", code: "NIU", telCode: "683" },
  { name: "Norfolk Island", code: "NFK", telCode: "672" },
  { name: "North Macedonia", code: "MKD", telCode: "389" },
  { name: "Northern Mariana Islands", code: "MNP", telCode: "1" },
  { name: "Norway", code: "NOR", telCode: "47" },
  { name: "Oman", code: "OMN", telCode: "968" },
  { name: "Pakistan", code: "PAK", telCode: "92" },
  { name: "Palau", code: "PLW", telCode: "680" },
  { name: "Palestine, State of", code: "PSE", telCode: "970" },
  { name: "Panama", code: "PAN", telCode: "507" },
  { name: "Papua New Guinea", code: "PNG", telCode: "675" },
  { name: "Paraguay", code: "PRY", telCode: "595" },
  { name: "Peru", code: "PER", telCode: "51" },
  { name: "Philippines", code: "PHL", telCode: "63" },
  { name: "Pitcairn", code: "PCN", telCode: "64" },
  { name: "Poland", code: "POL", telCode: "48" },
  { name: "Portugal", code: "PRT", telCode: "351" },
  { name: "Puerto Rico", code: "PRI", telCode: "1" },
  { name: "Qatar", code: "QAT", telCode: "974" },
  { name: "R\u00e9union", code: "REU", telCode: "262" },
  { name: "Romania", code: "ROU", telCode: "40" },
  { name: "Russian Federation", code: "RUS", telCode: "7" },
  { name: "Rwanda", code: "RWA", telCode: "250" },
  { name: "Saint Barth\u00e9lemy", code: "BLM", telCode: "590" },
  {
    name: "Saint Helena, Ascension and Tristan da Cunha",
    code: "SHN",
    telCode: "290",
  },
  { name: "Saint Kitts and Nevis", code: "KNA", telCode: "1" },
  { name: "Saint Lucia", code: "LCA", telCode: "1" },
  { name: "Saint Martin (French part)", code: "MAF", telCode: "590" },
  { name: "Saint Pierre and Miquelon", code: "SPM", telCode: "508" },
  { name: "Saint Vincent and the Grenadines", code: "VCT", telCode: "1" },
  { name: "Samoa", code: "WSM", telCode: "685" },
  { name: "San Marino", code: "SMR", telCode: "378" },
  { name: "Sao Tome and Principe", code: "STP", telCode: "239" },
  { name: "Saudi Arabia", code: "SAU", telCode: "966" },
  { name: "Senegal", code: "SEN", telCode: "221" },
  { name: "Serbia", code: "SRB", telCode: "381" },
  { name: "Seychelles", code: "SYC", telCode: "248" },
  { name: "Sierra Leone", code: "SLE", telCode: "232" },
  { name: "Singapore", code: "SGP", telCode: "65" },
  { name: "Sint Maarten (Dutch part)", code: "SXM", telCode: "1" },
  { name: "Slovakia", code: "SVK", telCode: "421" },
  { name: "Slovenia", code: "SVN", telCode: "386" },
  { name: "Solomon Islands", code: "SLB", telCode: "677" },
  { name: "Somalia", code: "SOM", telCode: "252" },
  { name: "South Africa", code: "ZAF", telCode: "27" },
  {
    name: "South Georgia and the South Sandwich Islands",
    code: "SGS",
    telCode: "500",
  },
  { name: "South Sudan", code: "SSD", telCode: "211" },
  { name: "Spain", code: "ESP", telCode: "34" },
  { name: "Sri Lanka", code: "LKA", telCode: "94" },
  { name: "Sudan", code: "SDN", telCode: "249" },
  { name: "Suriname", code: "SUR", telCode: "597" },
  { name: "Svalbard and Jan Mayen", code: "SJM", telCode: "47" },
  { name: "Sweden", code: "SWE", telCode: "46" },
  { name: "Switzerland", code: "CHE", telCode: "41" },
  { name: "Syrian Arab Republic", code: "SYR", telCode: "963" },
  { name: "Taiwan", code: "TWN", telCode: "886" },
  { name: "Tajikistan", code: "TJK", telCode: "992" },
  { name: "Tanzania, United Republic of", code: "TZA", telCode: "255" },
  { name: "Thailand", code: "THA", telCode: "66" },
  { name: "Timor-Leste", code: "TLS", telCode: "670" },
  { name: "Togo", code: "TGO", telCode: "228" },
  { name: "Tokelau", code: "TKL", telCode: "690" },
  { name: "Tonga", code: "TON", telCode: "676" },
  { name: "Trinidad and Tobago", code: "TTO", telCode: "1" },
  { name: "Tunisia", code: "TUN", telCode: "216" },
  { name: "Turkey", code: "TUR", telCode: "90" },
  { name: "Turkmenistan", code: "TKM", telCode: "993" },
  { name: "Turks and Caicos Islands", code: "TCA", telCode: "1" },
  { name: "Tuvalu", code: "TUV", telCode: "688" },
  { name: "Uganda", code: "UGA", telCode: "256" },
  { name: "Ukraine", code: "UKR", telCode: "380" },
  { name: "United Arab Emirates", code: "ARE", telCode: "971" },
  {
    name: "United Kingdom of Great Britain and Northern Ireland",
    code: "GBR",
    telCode: "44",
  },
  { name: "United States of America", code: "USA", telCode: "1" },
  { name: "Uruguay", code: "URY", telCode: "598" },
  { name: "Uzbekistan", code: "UZB", telCode: "998" },
  { name: "Vanuatu", code: "VUT", telCode: "678" },
  { name: "Venezuela (Bolivarian Republic of)", code: "VEN", telCode: "58" },
  { name: "Vietnam", code: "VNM", telCode: "84" },
  { name: "Virgin Islands (British)", code: "VGB", telCode: "1" },
  { name: "Virgin Islands (U.S.)", code: "VIR", telCode: "1 340" },
  { name: "Wallis and Futuna", code: "WLF", telCode: "681" },
  { name: "Western Sahara", code: "ESH", telCode: "212" },
  { name: "Yemen", code: "YEM", telCode: "967" },
  { name: "Zambia", code: "ZMB", telCode: "260" },
  { name: "Zimbabwe", code: "ZWE", telCode: "263" },
];

export default countries;
